<template>
    <div>
        <div class="table-layout expanded" v-if="showTable">
            <el-table :data="pageContractImpList" :height="tableHeight" ref="contractImpInfoTable" :expand-row-keys="expends" :row-key="getRowKeys" style="width: 100%" border :row-class-name="getRowClass" @expand-change="showManageDetail"
                      @selection-change="handleMainSelectionChange">
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <div class="sub-table-layout" style="padding: 20px 20px 20px 40px">
                            <el-table v-if="props.row.subImpInfos != null && props.row.subImpInfos.length > 0" :data="props.row.subImpInfos" border style="width: 100%" @selection-change="handleSelectionChange"
                                      :row-class-name="markSelectedRowClassName">
                                <el-table-column type="selection" width="40" align="center" fixed="left"></el-table-column>
                                <el-table-column :label="getFieldTitle('htBh', '合同编号', assetFieldMap)" v-if="viewFieldFlag('htBh', null, assetCustFileds, assetFieldMap)">
                                    <el-table-column prop="htBh" width="220">
                                        <template slot-scope="rows">
                                            <div v-if="!rows.row.validateInfo.htBh.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.htBh.errorMsg">
                                                <span>{{ rows.row.htBh }}</span>
                                            </div>
                                            <div v-else>{{ rows.row.htBh }}</div>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('skuId', 'SKUID', assetFieldMap)" v-if="viewFieldFlag('skuId', null, assetCustFileds, assetFieldMap)">
                                    <el-table-column prop="skuId" :render-header="setGoods">
                                        <template slot-scope="rows">
                                            <div v-if="!rows.row.validateInfo.skuId.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.skuId.errorMsg">
                                                <span>{{ rows.row.skuId }}</span>
                                            </div>
                                            <span v-else>{{ rows.row.skuId }}</span>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('goodsTitle', '商品名称', assetFieldMap)" v-if="viewFieldFlag('goodsTitle', null, assetCustFileds, assetFieldMap)">
                                    <el-table-column prop="goodsTitle">
                                        <template slot-scope="rows">
                                            <div v-if="!rows.row.validateInfo.goodsTitle.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.goodsTitle.errorMsg">
                                                <span>{{ rows.row.goodsTitle }}</span>
                                            </div>
                                            <span v-else>{{ rows.row.goodsTitle }}</span>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('innerCode', '资产定义编码', assetFieldMap)" v-if="viewFieldFlag('innerCode', null, assetCustFileds, assetFieldMap)">
                                    <el-table-column prop="innerCode" width="220">
                                        <template slot-scope="rows">
                                            <input type="text" v-if="!rows.row.validateInfo.innerCode.validateOk" @change="assetChangeEvent(rows.row)" style="background-color: #edd28b; width: 98%" v-model="rows.row.innerCode"
                                                   :title="rows.row.validateInfo.innerCode.errorMsg"/>
                                            <input type="text" v-else style="width:98%" @change="assetChangeEvent(rows.row)" v-model="rows.row.innerCode"/>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('name', '资产名称', assetFieldMap)" v-if="viewFieldFlag('name', null, assetCustFileds, assetFieldMap)">
                                    <el-table-column prop="name" width="260">
                                        <template slot-scope="rows">
                                            <div v-if="!rows.row.validateInfo.name.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.name.errorMsg">
                                                <span>{{ rows.row.name }}</span>
                                            </div>
                                            <div v-else>{{ rows.row.name }}</div>
                                            <!--<input type="text" v-if="!rows.row.validateInfo.name.validateOk" @change="assetChangeEvent(rows.row)" style="background-color: #edd28b; width:98%" v-model="rows.row.name" :title="rows.row.validateInfo.name.errorMsg"/>-->
                                            <!--<input type="text" v-else style="width:98%" @change="assetChangeEvent(rows.row)" v-model="rows.row.name"/>-->
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('assetTitle', '资产描述全称', assetFieldMap)" v-if="viewFieldFlag('assetTitle', null, assetCustFileds, assetFieldMap)">
                                    <el-table-column prop="assetTitle" width="260">
                                        <template slot-scope="rows">
                                            <div v-if="!rows.row.validateInfo.assetTitle.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.assetTitle.errorMsg">
                                                <span>{{ rows.row.assetTitle }}</span>
                                            </div>
                                            <div v-else>{{ rows.row.assetTitle }}</div>
                                            <!--<input type="text" v-if="!rows.row.validateInfo.assetTitle.validateOk" @change="assetChangeEvent(rows.row)" style="background-color: #edd28b; width:98%" v-model="rows.row.assetTitle" :title="rows.row.validateInfo.assetTitle.errorMsg"/>-->
                                            <!--<input type="text" v-else style="width:98%" @change="assetChangeEvent(rows.row)" v-model="rows.row.assetTitle"/>-->
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('innerDevcCode', '资产分类编码', assetFieldMap)" v-if="viewFieldFlag('innerDevcCode', null, assetCustFileds, assetFieldMap)">
                                    <el-table-column prop="innerDevcCode" width="180">
                                        <template slot-scope="rows">
                                            <div v-if="!rows.row.validateInfo.innerDevcCode.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.innerDevcCode.errorMsg">
                                                <span>{{ rows.row.innerDevcCode }}</span>
                                            </div>
                                            <div v-else>{{ rows.row.innerDevcCode }}</div>
                                            <!--<input type="text" v-if="!rows.row.validateInfo.innerDevcCode.validateOk" @change="assetChangeEvent(rows.row)" style="background-color: #edd28b; width:98%" v-model="rows.row.innerDevcCode" :title="rows.row.validateInfo.innerDevcCode.errorMsg"/>-->
                                            <!--<input type="text" v-else style="width:98%" @change="assetChangeEvent(rows.row)" v-model="rows.row.innerDevcCode"/>-->
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('brandName', '品牌', assetFieldMap)" v-if="viewFieldFlag('brandName', null, assetCustFileds, assetFieldMap)">
                                    <el-table-column prop="brandName" width="180">
                                        <template slot-scope="rows">
                                            <div v-if="!rows.row.validateInfo.brandName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.brandName.errorMsg">
                                                <span>{{ rows.row.brandName }}</span>
                                            </div>
                                            <div v-else>{{ rows.row.brandName }}</div>
                                            <!--<input type="text" v-if="!rows.row.validateInfo.brandName.validateOk" @change="assetChangeEvent(rows.row)" style="background-color: #edd28b; width:98%" v-model="rows.row.brandName" :title="rows.row.validateInfo.brandName.errorMsg"/>-->
                                            <!--<input type="text" v-else style="width:98%" @change="assetChangeEvent(rows.row)" v-model="rows.row.brandName"/>-->
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('theUnit', '单位', assetFieldMap)" v-if="viewFieldFlag('theUnit', null, assetCustFileds, assetFieldMap)">
                                    <el-table-column prop="theUnit" width="180">
                                        <template slot-scope="rows">
                                            <div v-if="!rows.row.validateInfo.theUnit.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.theUnit.errorMsg">
                                                <span>{{ rows.row.theUnit }}</span>
                                            </div>
                                            <div v-else>{{ rows.row.theUnit }}</div>
                                            <!--<input type="text" v-if="!rows.row.validateInfo.theUnit.validateOk" @change="assetChangeEvent(rows.row)" style="background-color: #edd28b; width:98%" v-model="rows.row.theUnit" :title="rows.row.validateInfo.theUnit.errorMsg"/>-->
                                            <!--<input type="text" v-else style="width:98%" @change="assetChangeEvent(rows.row)" v-model="rows.row.theUnit"/>-->
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('model', '型号', assetFieldMap)" v-if="viewFieldFlag('model', null, assetCustFileds, assetFieldMap)">
                                    <el-table-column prop="model" width="200">
                                        <template slot-scope="rows">
                                            <div v-if="!rows.row.validateInfo.model.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.model.errorMsg">
                                                <span>{{ rows.row.model }}</span>
                                            </div>
                                            <div v-else>{{ rows.row.model }}</div>
                                            <!--<input type="text" v-if="!rows.row.validateInfo.model.validateOk" @change="assetChangeEvent(rows.row)" style="background-color: #edd28b; width:98%" v-model="rows.row.model" :title="rows.row.validateInfo.model.errorMsg"/>-->
                                            <!--<input type="text" v-else style="width:98%" @change="assetChangeEvent(rows.row)" v-model="rows.row.model"/>-->
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('fixedSpec', '规格', assetFieldMap)" v-if="viewFieldFlag('fixedSpec', null, assetCustFileds, assetFieldMap)">
                                    <el-table-column prop="fixedSpec" width="200">
                                        <template slot-scope="rows">
                                            <div v-if="!rows.row.validateInfo.fixedSpec.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.fixedSpec.errorMsg">
                                                <span>{{ rows.row.fixedSpec }}</span>
                                            </div>
                                            <div v-else>{{ rows.row.fixedSpec }}</div>
                                            <!--<input type="text" v-if="!rows.row.validateInfo.fixedSpec.validateOk" @change="assetChangeEvent(rows.row)" style="background-color: #edd28b; width:98%" v-model="rows.row.fixedSpec" :title="rows.row.validateInfo.fixedSpec.errorMsg"/>-->
                                            <!--<input type="text" v-else style="width:98%" @change="assetChangeEvent(rows.row)" v-model="rows.row.fixedSpec"/>-->
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('bizAreaName', '区域名称', assetFieldMap)" v-if="viewFieldFlag('bizAreaName', null, assetCustFileds, assetFieldMap)">
                                    <el-table-column prop="bizAreaName" width="180">
                                        <template slot-scope="rows">
                                            <input type="text" v-if="!rows.row.validateInfo.bizAreaName.validateOk" @change="bizAreaChangeEvent(rows.row)" style="background-color: #edd28b; width: 98%" v-model="rows.row.bizAreaName"
                                                   :title="rows.row.validateInfo.bizAreaName.errorMsg"/>
                                            <input type="text" v-else style="width:98%" @change="bizAreaChangeEvent(rows.row)" v-model="rows.row.bizAreaName"/>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('bizAreaCode', '区域编码', assetFieldMap)" v-if="viewFieldFlag('bizAreaCode', null, assetCustFileds, assetFieldMap)">
                                    <el-table-column prop="bizAreaCode" width="180">
                                        <template slot-scope="rows">
                                            <input type="text" v-if="!rows.row.validateInfo.bizAreaCode.validateOk" @change="bizAreaChangeEvent(rows.row)" style="background-color: #edd28b; width: 98%" v-model="rows.row.bizAreaCode"
                                                   :title="rows.row.validateInfo.bizAreaCode.errorMsg"/>
                                            <input type="text" v-else style="width:98%" @change="bizAreaChangeEvent(rows.row)" v-model="rows.row.bizAreaCode"/>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('price', '含税价(元)', assetFieldMap)" align="right" v-if="viewFieldFlag('price', null, assetCustFileds, assetFieldMap)">
                                    <el-table-column prop="price" width="140" align="right">
                                        <template slot-scope="rows">
                                            <input class="align-right" v-if="!rows.row.validateInfo.price.validateOk" @change="commonChangeEvent" type="text" v-model="rows.row.price" style="background-color: #edd28b; width: 98%"
                                                   :title="rows.row.validateInfo.price.errorMsg"/>
                                            <input class="align-right" v-else type="text" @change="commonChangeEvent" v-model="rows.row.price" style="width: 98%"/>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('wrntPeriod', '质保期(月)', assetFieldMap)" align="right" v-if="viewFieldFlag('wrntPeriod', null, assetCustFileds, assetFieldMap)">
                                    <el-table-column prop="wrntPeriod" width="140" align="right">
                                        <template slot-scope="rows">
                                            <input class="align-right" v-if="!rows.row.validateInfo.wrntPeriod.validateOk" @change="commonChangeEvent" type="text" v-model="rows.row.wrntPeriod" style="background-color: #edd28b; width: 98%"
                                                   :title="rows.row.validateInfo.wrntPeriod.errorMsg"/>
                                            <input class="align-right" v-else type="text" @change="commonChangeEvent" v-model="rows.row.wrntPeriod" style="width: 98%"/>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('bizFormNames', '经营业态', assetFieldMap)" v-if="viewFieldFlag('bizFormNames', null, assetCustFileds, assetFieldMap)">
                                    <el-table-column prop="bizFormNames" :render-header="setBizFormNames">
                                        <template slot-scope="rows">
                                            <div v-if="!rows.row.validateInfo.bizFormNames.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.bizFormNames.errorMsg">
                                                <span>{{ rows.row.bizFormNames }}</span>
                                            </div>
                                            <span v-else>{{ rows.row.bizFormNames }}</span>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                            </el-table>
                            <el-table v-if="props.row.asmblImpInfos != null && props.row.asmblImpInfos.length > 0" :data="props.row.asmblImpInfos" border style="width: 100%; margin-top: 5px;" @selection-change="handleSelectionChange"
                                      :row-class-name="markSelectedRowClassName">
                                <el-table-column type="selection" width="40" align="center" fixed="left"></el-table-column>
                                <el-table-column :label="getFieldTitle('htBh', '合同编号', asmblFieldMap)" v-if="viewFieldFlag('htBh', null, asmblCustFileds, asmblFieldMap)">
                                    <el-table-column prop="htBh" width="220">
                                        <template slot-scope="rows">
                                            <div v-if="!rows.row.validateInfo.htBh.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.htBh.errorMsg">
                                                <span>{{ rows.row.htBh }}</span>
                                            </div>
                                            <div v-else>{{ rows.row.htBh }}</div>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('skuId', 'SKUID', assetFieldMap)" v-if="viewFieldFlag('skuId', null, assetCustFileds, assetFieldMap)">
                                    <el-table-column prop="skuId" :render-header="setGoods">
                                        <template slot-scope="rows">
                                            <div v-if="!rows.row.validateInfo.skuId.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.skuId.errorMsg">
                                                <span>{{ rows.row.skuId }}</span>
                                            </div>
                                            <span v-else>{{ rows.row.skuId }}</span>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('goodsTitle', '商品名称', assetFieldMap)" v-if="viewFieldFlag('goodsTitle', null, assetCustFileds, assetFieldMap)">
                                    <el-table-column prop="goodsTitle">
                                        <template slot-scope="rows">
                                            <div v-if="!rows.row.validateInfo.goodsTitle.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.goodsTitle.errorMsg">
                                                <span>{{ rows.row.goodsTitle }}</span>
                                            </div>
                                            <span v-else>{{ rows.row.goodsTitle }}</span>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('innerCode', '组装件定义编码', asmblFieldMap)" v-if="viewFieldFlag('innerCode', null, asmblCustFileds, asmblFieldMap)">
                                    <el-table-column prop="innerCode" width="220">
                                        <template slot-scope="rows">
                                            <input type="text" v-if="!rows.row.validateInfo.innerCode.validateOk" @change="asmblChangeEvent(rows.row)" style="background-color: #edd28b; width: 98%" v-model="rows.row.innerCode"
                                                   :title="rows.row.validateInfo.innerCode.errorMsg"/>
                                            <input type="text" v-else style="width:98%" @change="asmblChangeEvent(rows.row)" v-model="rows.row.innerCode"/>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('name', '组装件名称', asmblFieldMap)" v-if="viewFieldFlag('name', null, asmblCustFileds, asmblFieldMap)">
                                    <el-table-column prop="name" width="260">
                                        <template slot-scope="rows">
                                            <div v-if="!rows.row.validateInfo.name.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.name.errorMsg">
                                                <span>{{ rows.row.name }}</span>
                                            </div>
                                            <div v-else>{{ rows.row.name }}</div>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('assetTitle', '组装件描述全称', asmblFieldMap)" v-if="viewFieldFlag('assetTitle', null, asmblCustFileds, asmblFieldMap)">
                                    <el-table-column prop="assetTitle" width="260">
                                        <template slot-scope="rows">
                                            <div v-if="!rows.row.validateInfo.assetTitle.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.assetTitle.errorMsg">
                                                <span>{{ rows.row.assetTitle }}</span>
                                            </div>
                                            <div v-else>{{ rows.row.assetTitle }}</div>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('brandName', '品牌', asmblFieldMap)" v-if="viewFieldFlag('brandName', null, asmblCustFileds, asmblFieldMap)">
                                    <el-table-column prop="brandName" width="180">
                                        <template slot-scope="rows">
                                            <div v-if="!rows.row.validateInfo.brandName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.brandName.errorMsg">
                                                <span>{{ rows.row.brandName }}</span>
                                            </div>
                                            <div v-else>{{ rows.row.brandName }}</div>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('theUnit', '单位', asmblFieldMap)" v-if="viewFieldFlag('theUnit', null, asmblCustFileds, asmblFieldMap)">
                                    <el-table-column prop="theUnit" width="180">
                                        <template slot-scope="rows">
                                            <div v-if="!rows.row.validateInfo.theUnit.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.theUnit.errorMsg">
                                                <span>{{ rows.row.theUnit }}</span>
                                            </div>
                                            <div v-else>{{ rows.row.theUnit }}</div>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('model', '型号', asmblFieldMap)" v-if="viewFieldFlag('model', null, asmblCustFileds, asmblFieldMap)">
                                    <el-table-column prop="model" width="200">
                                        <template slot-scope="rows">
                                            <div v-if="!rows.row.validateInfo.model.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.model.errorMsg">
                                                <span>{{ rows.row.model }}</span>
                                            </div>
                                            <div v-else>{{ rows.row.model }}</div>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('fixedSpec', '规格', asmblFieldMap)" v-if="viewFieldFlag('fixedSpec', null, asmblCustFileds, asmblFieldMap)">
                                    <el-table-column prop="fixedSpec" width="200">
                                        <template slot-scope="rows">
                                            <div v-if="!rows.row.validateInfo.fixedSpec.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.fixedSpec.errorMsg">
                                                <span>{{ rows.row.fixedSpec }}</span>
                                            </div>
                                            <div v-else>{{ rows.row.fixedSpec }}</div>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('bizAreaName', '区域名称', asmblFieldMap)" v-if="viewFieldFlag('bizAreaName', null, asmblCustFileds, asmblFieldMap)">
                                    <el-table-column prop="bizAreaName" width="180">
                                        <template slot-scope="rows">
                                            <input type="text" v-if="!rows.row.validateInfo.bizAreaName.validateOk" @change="bizAreaChangeEvent(rows.row)" style="background-color: #edd28b; width: 98%" v-model="rows.row.bizAreaName"
                                                   :title="rows.row.validateInfo.bizAreaName.errorMsg"/>
                                            <input type="text" v-else style="width:98%" @change="bizAreaChangeEvent(rows.row)" v-model="rows.row.bizAreaName"/>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('bizAreaCode', '区域编码', asmblFieldMap)" v-if="viewFieldFlag('bizAreaCode', null, asmblCustFileds, asmblFieldMap)">
                                    <el-table-column prop="bizAreaCode" width="180">
                                        <template slot-scope="rows">
                                            <input type="text" v-if="!rows.row.validateInfo.bizAreaCode.validateOk" @change="bizAreaChangeEvent(rows.row)" style="background-color: #edd28b; width: 98%" v-model="rows.row.bizAreaCode"
                                                   :title="rows.row.validateInfo.bizAreaCode.errorMsg"/>
                                            <input type="text" v-else style="width:98%" @change="bizAreaChangeEvent(rows.row)" v-model="rows.row.bizAreaCode"/>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('price', '含税价(元)', asmblFieldMap)" align="right" v-if="viewFieldFlag('price', null, asmblCustFileds, asmblFieldMap)">
                                    <el-table-column prop="price" width="180" align="right">
                                        <template slot-scope="rows">
                                            <input class="align-right" v-if="!rows.row.validateInfo.price.validateOk" @change="commonChangeEvent" type="text" v-model="rows.row.price" style="background-color: #edd28b; width: 98%"
                                                   :title="rows.row.validateInfo.price.errorMsg"/>
                                            <input class="align-right" v-else type="text" @change="commonChangeEvent" v-model="rows.row.price" style="width: 98%"/>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('wrntPeriod', '质保期(月)', asmblFieldMap)" align="right" v-if="viewFieldFlag('wrntPeriod', null, asmblCustFileds, asmblFieldMap)">
                                    <el-table-column prop="wrntPeriod" width="180" align="right">
                                        <template slot-scope="rows">
                                            <input class="align-right" v-if="!rows.row.validateInfo.wrntPeriod.validateOk" @change="commonChangeEvent" type="text" v-model="rows.row.wrntPeriod" style="background-color: #edd28b; width: 98%"
                                                   :title="rows.row.validateInfo.wrntPeriod.errorMsg"/>
                                            <input class="align-right" v-else type="text" @change="commonChangeEvent" v-model="rows.row.wrntPeriod" style="width: 98%"/>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('bizFormNames', '经营业态', asmblFieldMap)" v-if="viewFieldFlag('bizFormNames', null, asmblCustFileds, asmblFieldMap)">
                                    <el-table-column prop="bizFormNames" :render-header="setBizFormNames">
                                        <template slot-scope="rows">
                                            <div v-if="!rows.row.validateInfo.bizFormNames.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.bizFormNames.errorMsg">
                                                <span>{{ rows.row.bizFormNames }}</span>
                                            </div>
                                            <span v-else>{{ rows.row.bizFormNames }}</span>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                            </el-table>
                            <el-table v-if="props.row.feeItemImpInfos != null && props.row.feeItemImpInfos.length > 0" :data="props.row.feeItemImpInfos" border style="width: 100%; margin-top: 5px;" @selection-change="handleSelectionChange"
                                      :row-class-name="markSelectedRowClassName">
                                <el-table-column type="selection" width="40" align="center" fixed="left"></el-table-column>
                                <el-table-column :label="getFieldTitle('htBh', '合同编号', feeFieldMap)" v-if="viewFieldFlag('htBh', null, feeCustFileds, feeFieldMap)">
                                    <el-table-column prop="htBh">
                                        <template slot-scope="rows">
                                            <div v-if="!rows.row.validateInfo.htBh.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.htBh.errorMsg">
                                                <span>{{ rows.row.htBh }}</span>
                                            </div>
                                            <div v-else>{{ rows.row.htBh }}</div>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('feeTypeText', '费用类型', feeFieldMap)" v-if="viewFieldFlag('feeTypeText', null, feeCustFileds, feeFieldMap)">
                                    <el-table-column prop="innerCode">
                                        <template slot-scope="rows">
                                            <el-select v-model="rows.row.feeTypeText" placeholder="请选择" @change="commonChangeEvent">
                                                <el-option v-for="purchFeeType in purchFeeTypeList" :key="purchFeeType.value" :label="purchFeeType.text" :value="purchFeeType.text"></el-option>
                                            </el-select>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('feeName', '名称', feeFieldMap)" v-if="viewFieldFlag('feeName', null, feeCustFileds, feeFieldMap)">
                                    <el-table-column prop="name">
                                        <template slot-scope="rows">
                                            <input type="text" v-if="!rows.row.validateInfo.feeName.validateOk" style="background-color: #edd28b; width: 98%" v-model="rows.row.feeName" :title="rows.row.validateInfo.feeName.errorMsg"/>
                                            <input type="text" v-else style="width:98%" @change="commonChangeEvent" v-model="rows.row.feeName"/>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('feeBrandName', '品牌', feeFieldMap)" v-if="viewFieldFlag('feeBrandName', null, feeCustFileds, feeFieldMap)">
                                    <el-table-column prop="assetTitle">
                                        <template slot-scope="rows">
                                            <input type="text" v-if="!rows.row.validateInfo.feeBrandName.validateOk" style="background-color: #edd28b; width: 98%" v-model="rows.row.feeBrandName"
                                                   :title="rows.row.validateInfo.feeBrandName.errorMsg"/>
                                            <input type="text" v-else style="width:98%" @change="commonChangeEvent" v-model="rows.row.feeBrandName"/>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('feeModelSpec', '规格', feeFieldMap)" v-if="viewFieldFlag('feeModelSpec', null, feeCustFileds, feeFieldMap)">
                                    <el-table-column prop="brandName">
                                        <template slot-scope="rows">
                                            <input type="text" v-if="!rows.row.validateInfo.feeModelSpec.validateOk" style="background-color: #edd28b; width: 98%" v-model="rows.row.feeModelSpec"
                                                   :title="rows.row.validateInfo.feeModelSpec.errorMsg"/>
                                            <input type="text" v-else style="width:98%" @change="commonChangeEvent" v-model="rows.row.feeModelSpec"/>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('feeUnit', '单位', feeFieldMap)" v-if="viewFieldFlag('feeUnit', null, feeCustFileds, feeFieldMap)">
                                    <el-table-column prop="theUnit">
                                        <template slot-scope="rows">
                                            <input type="text" v-if="!rows.row.validateInfo.feeUnit.validateOk" style="background-color: #edd28b; width: 98%" v-model="rows.row.feeUnit" :title="rows.row.validateInfo.feeUnit.errorMsg"/>
                                            <input type="text" v-else style="width:98%" @change="commonChangeEvent" v-model="rows.row.feeUnit"/>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column :label="getFieldTitle('feePrice', '单价(元)', feeFieldMap)" v-if="viewFieldFlag('feePrice', null, feeCustFileds, feeFieldMap)">
                                    <el-table-column prop="model">
                                        <template slot-scope="rows">
                                            <input type="number" v-if="!rows.row.validateInfo.feePrice.validateOk" style="background-color: #edd28b; width: 98%" v-model="rows.row.feePrice" :title="rows.row.validateInfo.feePrice.errorMsg"/>
                                            <input type="number" v-else style="width:98%" @change="commonChangeEvent" v-model="rows.row.feePrice"/>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                            </el-table>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column type="selection" width="40" align="center" fixed="left"></el-table-column>
                <el-table-column label="行号" prop="rowNo" width="60" align="center">
                    <template slot-scope="rows">
                        <span class="font-gray3" v-if="rows.row.virtualRow">虚拟行</span>
                        <span v-else>{{ rows.row.rowNo }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="failed" label="执行状态" width="60" align="center" v-show="startFlag">
                    <template slot-scope="rows">
                        <div v-if="rows.row.failed != null">
                            <span v-if="rows.row.failed" style="color: red;font-size: 20px">×</span>
                            <span v-else style="color: green;font-size: 20px">√</span>
                        </div>
                        <span v-else class="font-gray3">未执行</span>
                    </template>
                </el-table-column>
                <el-table-column prop="failDesc" label="失败描述" align="left" v-show="startFlag"></el-table-column>
                <el-table-column :label="getFieldTitle('fstPartyRealComName', '买方公司', contractFieldMap)" v-if="viewFieldFlag('fstPartyRealComName', null, contractCustFileds, contractFieldMap)">
                    <el-table-column prop="fstPartyRealComName" :render-header="setFstPartyRealComInfo">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.fstPartyRealComName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.fstPartyRealComName.errorMsg">
                                <span>{{ rows.row.fstPartyRealComName }}</span>
                            </div>
                            <span v-else>{{ rows.row.fstPartyRealComName }}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column :label="getFieldTitle('title', '合同名称', contractFieldMap)" prop="title" width="200" v-if="viewFieldFlag('title', null, contractCustFileds, contractFieldMap)">
                    <template slot-scope="rows">
                        <input type="text" :disabled="rows.row.virtualRow" v-if="!rows.row.validateInfo.title.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width:98%" v-model="rows.row.title"
                               :title="rows.row.validateInfo.title.errorMsg"/>
                        <input type="text" :disabled="rows.row.virtualRow" v-else style="width:98%" @change="commonChangeEvent" v-model="rows.row.title"/>
                    </template>
                </el-table-column>
                <el-table-column :label="getFieldTitle('htBh', '合同编号', contractFieldMap)" prop="htBh" width="200" v-if="viewFieldFlag('htBh', null, contractCustFileds, contractFieldMap)">
                    <template slot-scope="rows">
                        <div v-if="!rows.row.validateInfo.htBh.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.htBh.errorMsg">
                            <span>{{ rows.row.htBh }}</span>
                        </div>
                        <div v-else>{{ rows.row.htBh }}</div>
                    </template>
                </el-table-column>
                <el-table-column :label="getFieldTitle('sndPartyName', '供应商名称', contractFieldMap)" prop="sndPartyName" width="200" v-if="viewFieldFlag('sndPartyName', null, contractCustFileds, contractFieldMap)">
                    <template slot-scope="rows">
                        <div v-if="!rows.row.validateInfo.sndPartyName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.sndPartyName.errorMsg">
                            <span>{{ rows.row.sndPartyName }}</span>
                        </div>
                        <div v-else>{{ rows.row.sndPartyName }}</div>
                        <!--<input type="text" :disabled="rows.row.virtualRow" v-if="!rows.row.validateInfo.sndPartyName.validateOk" @change="vendorChangeEvent(rows.row)" style="background-color: #edd28b; width:98%" v-model="rows.row.sndPartyName" :title="rows.row.validateInfo.sndPartyName.errorMsg"/>-->
                        <!--<input type="text" :disabled="rows.row.virtualRow" v-else style="width:98%" @change="vendorChangeEvent(rows.row)" v-model="rows.row.sndPartyName"/>-->
                    </template>
                </el-table-column>
                <el-table-column :label="getFieldTitle('sndPartyRealComName', '卖方公司', contractFieldMap)" v-if="viewFieldFlag('sndPartyRealComName', null, contractCustFileds, contractFieldMap)">
                    <el-table-column prop="sndPartyRealComName" :render-header="setSndPartyRealComInfo">
                        <template slot-scope="rows">
                            <div v-if="!rows.row.validateInfo.sndPartyRealComName.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.sndPartyRealComName.errorMsg">
                                <span>{{ rows.row.sndPartyRealComName }}</span>
                            </div>
                            <span v-else>{{ rows.row.sndPartyRealComName }}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column :label="getFieldTitle('sndPartyNo', '供应商统一社会信用代码', contractFieldMap)" prop="sndPartyNo" width="200" v-if="viewFieldFlag('sndPartyNo', null, contractCustFileds, contractFieldMap)">
                    <template slot-scope="rows">
                        <input type="text" :disabled="rows.row.virtualRow || fileObj.extra.updateFlag" v-if="!rows.row.validateInfo.sndPartyNo.validateOk" @change="vendorChangeEvent(rows.row)" style="background-color: #edd28b; width:98%"
                               v-model="rows.row.sndPartyNo" :title="rows.row.validateInfo.sndPartyNo.errorMsg"/>
                        <input type="text" :disabled="rows.row.virtualRow || fileObj.extra.updateFlag" v-else style="width:98%" @change="vendorChangeEvent(rows.row)" v-model="rows.row.sndPartyNo"/>
                    </template>
                </el-table-column>
                <el-table-column :label="getFieldTitle('dateStart', '开始时间', contractFieldMap)" prop="dateStart" width="140" v-if="viewFieldFlag('dateStart', null, contractCustFileds, contractFieldMap)">
                    <template slot-scope="rows">
                        <!--<div v-if="!rows.row.validateInfo.dateStart.validateOk" style="background-color: #edd28b; width: 95%;height: 100%" :title="rows.row.validateInfo.dateStart.errorMsg">-->
                        <!--<el-date-picker :disabled="rows.row.virtualRow" style="width: 95%" v-model="rows.row.dateStart" @change="commonChangeEvent" type="date" placeholder="选择日期" :picker-options="pickerOptions0" value-format="yyyy-MM-dd"></el-date-picker>-->
                        <!--</div>-->
                        <el-date-picker style="width: 95%" v-model="rows.row.dateStart" @change="commonChangeEvent" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
                    </template>
                </el-table-column>
                <el-table-column :label="getFieldTitle('dateEnd', '结束时间', contractFieldMap)" prop="dateEnd" width="140" v-if="viewFieldFlag('dateEnd', null, contractCustFileds, contractFieldMap)">
                    <template slot-scope="rows">
                        <!--<div v-if="!rows.row.validateInfo.dateEnd.validateOk" style="background-color: #edd28b; width: 95%;height: 100%" :title="rows.row.validateInfo.dateEnd.errorMsg">-->
                        <!--<el-date-picker :disabled="rows.row.virtualRow" style="width: 95%" v-model="rows.row.dateEnd" @change="commonChangeEvent" type="date" placeholder="选择日期" :picker-options="pickerOptions0" value-format="yyyy-MM-dd"></el-date-picker>-->
                        <!--</div>-->
                        <el-date-picker style="width: 95%" v-model="rows.row.dateEnd" @change="commonChangeEvent" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
                    </template>
                </el-table-column>
                <el-table-column :label="getFieldTitle('signDate', '签署日期', contractFieldMap)" prop="signDate" width="140" v-if="viewFieldFlag('signDate', null, contractCustFileds, contractFieldMap)">
                    <template slot-scope="rows">
                        <el-date-picker style="width: 95%" v-model="rows.row.signDate" @change="commonChangeEvent" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
                    </template>
                </el-table-column>
                <el-table-column :label="getFieldTitle('desireArriveDays', '到货期限(天)', contractFieldMap)" prop="desireArriveDays" width="140" v-if="viewFieldFlag('desireArriveDays', null, contractCustFileds, contractFieldMap)">
                    <template slot-scope="rows">
                        <input class="align-right" v-if="!rows.row.validateInfo.desireArriveDays.validateOk" @change="commonChangeEvent" type="number" style="background-color: #edd28b; width: 90px" size="6"
                               v-model="rows.row.desireArriveDays" :min="0" :max="100000" :title="rows.row.validateInfo.desireArriveDays.errorMsg"/>
                        <input class="align-right" v-else type="number" size="6" @change="commonChangeEvent" v-model="rows.row.desireArriveDays" :min="0" :max="100000" style="width: 90px"/>
                    </template>
                </el-table-column>
                <el-table-column :label="getFieldTitle('taxRate', '税率(%)', contractFieldMap)" prop="taxRate" width="120" align="right" v-if="viewFieldFlag('taxRate', null, contractCustFileds, contractFieldMap)">
                    <template slot-scope="rows">
                        <input type="text" class="align-right" :disabled="rows.row.virtualRow" v-if="!rows.row.validateInfo.taxRate.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 98%"
                               v-model="rows.row.taxRate" :title="rows.row.validateInfo.taxRate.errorMsg"/>
                        <input type="text" class="align-right" :disabled="rows.row.virtualRow" v-else style="width: 98%" @change="commonChangeEvent" v-model="rows.row.taxRate"/>
                    </template>
                </el-table-column>
                <el-table-column :label="getFieldTitle('payPhaseTplName', '付款阶段模板', contractFieldMap)" prop="payPhaseTplName" width="200" v-if="viewFieldFlag('payPhaseTplName', null, contractCustFileds, contractFieldMap)">
                    <template slot-scope="rows">
                        <div>{{ rows.row.payPhaseTplName }}</div>
                    </template>
                </el-table-column>
                <el-table-column :label="getFieldTitle('invoiceType', '发票类型', contractFieldMap)" prop="invoiceType" width="130" v-if="viewFieldFlag('invoiceTypeText', null, contractCustFileds, contractFieldMap)">
                    <template slot-scope="rows">
                        <el-select v-model="rows.row.invoiceType" placeholder="请选择" @change="invoiceTypeChange(rows.row)">
                            <el-option v-for="invoiceType in invoiceTypeList" :key="invoiceType.value" :label="invoiceType.text" :value="invoiceType.value"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column :label="getFieldTitle('invoiceTitle', '发票抬头', contractFieldMap)" prop="invoiceTitle" width="200" v-if="viewFieldFlag('invoiceTitle', null, contractCustFileds, contractFieldMap)">
                    <template slot-scope="rows">
                        <input type="text" class="align-left" :disabled="rows.row.virtualRow" v-if="!rows.row.validateInfo.invoiceTitle.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 98%"
                               v-model="rows.row.invoiceTitle" :title="rows.row.validateInfo.invoiceTitle.errorMsg"/>
                        <input type="text" class="align-left" :disabled="rows.row.virtualRow" v-else style="width: 98%" @change="commonChangeEvent" v-model="rows.row.invoiceTitle"/>
                    </template>
                </el-table-column>
                <el-table-column :label="getFieldTitle('invoiceContentTag', '发票内容标签', contractFieldMap)" prop="invoiceContentTag" width="200" v-if="viewFieldFlag('invoiceContentTag', null, contractCustFileds, contractFieldMap)">
                    <template slot-scope="rows">
                        <input type="text" class="align-left" :disabled="rows.row.virtualRow" v-if="!rows.row.validateInfo.invoiceContentTag.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 98%"
                               v-model="rows.row.invoiceContentTag" :title="rows.row.validateInfo.invoiceContentTag.errorMsg"/>
                        <input type="text" class="align-left" :disabled="rows.row.virtualRow" v-else style="width: 98%" @change="commonChangeEvent" v-model="rows.row.invoiceContentTag"/>
                    </template>
                </el-table-column>
                <el-table-column :label="getFieldTitle('taxPayerNo', '纳税人识别号', contractFieldMap)" prop="taxPayerNo" width="200" v-if="viewFieldFlag('taxPayerNo', null, contractCustFileds, contractFieldMap)">
                    <template slot-scope="rows">
                        <input type="text" class="align-left" :disabled="rows.row.virtualRow" v-if="!rows.row.validateInfo.taxPayerNo.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 98%"
                               v-model="rows.row.taxPayerNo" :title="rows.row.validateInfo.taxPayerNo.errorMsg"/>
                        <input type="text" class="align-left" :disabled="rows.row.virtualRow" v-else style="width: 98%" @change="commonChangeEvent" v-model="rows.row.taxPayerNo"/>
                    </template>
                </el-table-column>
                <el-table-column :label="getFieldTitle('signGroupName', '合同适用范围', contractFieldMap)" prop="signGroupName" width="200" v-if="viewFieldFlag('signGroupName', null, contractCustFileds, contractFieldMap)">
                    <template slot-scope="rows">
                        <input type="text" class="align-left" :disabled="rows.row.virtualRow" v-if="!rows.row.validateInfo.signGroupName.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 98%"
                               v-model="rows.row.signGroupName" :title="rows.row.validateInfo.signGroupName.errorMsg"/>
                        <input type="text" class="align-left" :disabled="rows.row.virtualRow" v-else style="width: 98%" @change="commonChangeEvent" v-model="rows.row.signGroupName"/>
                    </template>
                </el-table-column>
                <el-table-column :label="getFieldTitle('taxOffset', '购置可抵税', contractFieldMap)" class="align-center" prop="taxOffset" width="100" v-if="viewFieldFlag('taxOffset', null, contractCustFileds, contractFieldMap)">
                    <template slot-scope="rows">
                        <span v-if="rows.row.taxOffset">是</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column>
                <el-table-column :label="getFieldTitle('settleCrossOrderAllowed', '跨订单结算', contractFieldMap)" align="center" v-if="viewFieldFlag('settleCrossOrderAllowed', null, contractCustFileds, contractFieldMap)">
                    <el-table-column prop="settleCrossOrderAllowed" width="70" align="center">
                        <template slot-scope="rows">
                            <input type="checkbox" v-model="rows.row.settleCrossOrderAllowed" @change="commonChangeEvent(rows.row)"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column :label="getFieldTitle('settleAutoFlag', '自动结算', contractFieldMap)" align="center" v-if="viewFieldFlag('settleAutoFlag', null, contractCustFileds, contractFieldMap)">
                    <el-table-column prop="settleAutoFlag" width="70" align="center">
                        <template slot-scope="rows">
                            <input type="checkbox" v-model="rows.row.settleAutoFlag" @change="commonChangeEvent(rows.row)"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column :label="getFieldTitle('settlePeriodDay', '结算周期(每月x号)', contractFieldMap)" align="center" v-if="viewFieldFlag('settlePeriodDay', null, contractCustFileds, contractFieldMap)">
                    <el-table-column prop="settlePeriodDay" width="70" align="center">
                        <template slot-scope="rows">
                            <input class="align-right" type="number" size="6" @change="commonChangeEvent(rows.row)" v-model="rows.row.settlePeriodDay" :min="1" :max="28" style="width: 90px"/>
                        </template>
                    </el-table-column>
                </el-table-column>
            </el-table>
        </div>
        <div class="clearfix">
            <el-pagination background class="fl mt5" v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange"
                           layout="prev, pager, next, jumper, sizes, total"></el-pagination>
            <div class="swb-btn swb-btn-small fr mt10" @click="downloadContractImpModel">导出全部合同</div>
            <div class="swb-btn swb-btn-small fr mt10 mr10" @click="doContractImpModelImport">执行导入</div>
            <div class="swb-btn swb-btn-small fr mt10 mr10" @click="validateContractImpModel(true)">逐条检查</div>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'
    import {openPageRouteUrl, getDefaultPageSizes} from '../../../src/app.conf'
    import {openBizFormSelectionDlg} from '../bizForm/selectDlg'
    import {selectMerchantRealComDlg, selectRealAdoptedComDlg} from '../realCom/dialog'
    import {getMerchantBizParam} from '../asset/assetMain'
    import {openSkuListSelectDlg} from '../goods/selectDlg'

    import contractApi from '../../api/contract'
    import vendorApi from '../../api/vendor'
    import devcDefApi from '../../api/devcDef'
    import asmblAccApi from '../../api/asmblAcc'
    import bizAreaApi from '../../api/bizArea'
    import merchtFinacApi from '../../api/merchtFinac'
    import merchtComnApi from '../../api/merchtComn'
    import userApi from '../../api/user'
    import comnApi from '../../api/comn'

    export default {
        name: 'swb-contract-imp-check',
        desc: '合同导入检查',
        props: ['scopeId', 'fileObj', 'rootWidth', 'rootHeight', 'theDlg'],
        data: function () {
            return {
                tableHeight: 0,
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: [15, 50, 100, 200],// 特殊页面处理
                pageContractImpList: [],
                contractImpDto: {
                    originalFileName: null,
                    impInfoList: []
                },
                expends: [],
                invoiceContentTagList: [],
                invoiceTypeList: null,
                invoiceTypeMaps: getEnumMap('invoiceType', 'value2text'),
                purchFeeTypeList: getEnumList("purchFeeType"),
                //
                isOk: false,
                theLoading: null,
                multipleSelectionMain: [],
                multipleSelection: [],
                retailerInfo: null,
                max_quantity_per_item: 500,
                startFlag: false, // 标记是否已开始逐条执行
                nextIndex: 0,
                checkNextIndex: 0,
                scopeId: null,
                assetDeprMethodList: [],
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                fstPartyId: null,
                fstPartyType: null,
                //
                showTable: false,
                usage: "contract.by.goods.import",
                contractCustFileds: [],
                contractFieldMap: {},
                assetCustFileds: [],
                assetFieldMap: {},
                asmblCustFileds: [],
                asmblFieldMap: {},
                feeCustFileds: [],
                feeFieldMap: {}
            }
        },
        watch: {
            rootWidth(newVal, oldVal) {
                //
            },
            rootHeight(newVal, oldVal) {
                this.recalcTableHeight();
            }
        },
        created: function () {
            this.recalcTableHeight();
            this.assetDeprMethodList = getEnumList('assetDeprMethod');
            let invoiceTypeList = getEnumList("invoiceType");
            for (let i = 0; i < invoiceTypeList.length; i++) {
                let invoiceType = invoiceTypeList[i];
                if (invoiceType.value == 0 || invoiceType.value == 3) {
                    invoiceTypeList.splice(i, 1);
                    i--;
                }
            }
            this.invoiceTypeList = Utils.merge([], invoiceTypeList);
            //
            let self = this;
            getMerchantBizParam("display.asset.related.info.in.trading", function (result) {
                let showAssetInfo = Utils.isTrue(result);
                if (showAssetInfo) {
                    self.usage = "contract.by.def.import";
                }
                self.getComnXportConfByUsage(self.usage);
            });
            //
            let theLoading = MsgBox.loading();
            this.contractImpDto.originalFileName = this.fileObj.extra.originalFileName;
            let contractImpInfoList = this.fileObj.extra.contractImpInfoList || [];
            contractImpInfoList.forEach(function (el) {
                el.validateInfo = {
                    title: {validateOk: true},
                    htBh: {validateOk: true},
                    fstPartyRealComName: {validateOk: true},
                    sndPartyRealComName: {validateOk: true},
                    sndPartyName: {validateOk: true},
                    sndPartyNo: {validateOk: true},
                    dateStart: {validateOk: true},
                    dateEnd: {validateOk: true},
                    signDate: {validateOk: true},
                    desireArriveDays: {validateOk: true},
                    taxRate: {validateOk: true},
                    invoiceTypeText: {validateOk: true},
                    invoiceTitle: {validateOk: true},
                    invoiceContentTag: {validateOk: true},
                    taxPayerNo: {validateOk: true},
                    signGroupName: {validateOk: true}
                };
                //
                let dateStart = el.dateStart;
                let dateEnd = el.dateEnd;
                let signDate = el.signDate;
                if (!Utils.isNoB(dateStart) && Utils.isNumber(dateStart)) {
                    el.dateStart = new Date(dateStart).format("yyyy-MM-dd");
                }
                if (!Utils.isNoB(dateEnd) && Utils.isNumber(dateEnd)) {
                    el.dateEnd = new Date(dateEnd).format("yyyy-MM-dd");
                }
                if (!Utils.isNoB(signDate) && Utils.isNumber(signDate)) {
                    el.signDate = new Date(signDate).format("yyyy-MM-dd");
                }
                //
                let subImpInfos = el.subImpInfos || [];
                subImpInfos.forEach(function (subEel) {
                    subEel.validateInfo = {
                        htBh: {validateOk: true},
                        skuId: {validateOk: true},
                        goodsTitle: {validateOk: true},
                        innerCode: {validateOk: true},
                        name: {validateOk: true},
                        assetTitle: {validateOk: true},
                        innerDevcCode: {validateOk: true},
                        brandName: {validateOk: true},
                        theUnit: {validateOk: true},
                        model: {validateOk: true},
                        fixedSpec: {validateOk: true},
                        bizAreaName: {validateOk: true},
                        bizAreaCode: {validateOk: true},
                        price: {validateOk: true},
                        wrntPeriod: {validateOk: true},
                        bizFormNames: {validateOk: true}
                    };
                });
                //
                let asmblImpInfos = el.asmblImpInfos || [];
                asmblImpInfos.forEach(function (subEel) {
                    subEel.validateInfo = {
                        htBh: {validateOk: true},
                        skuId: {validateOk: true},
                        goodsTitle: {validateOk: true},
                        fstPartyRealComName: {validateOk: true},
                        sndPartyRealComName: {validateOk: true},
                        innerCode: {validateOk: true},
                        name: {validateOk: true},
                        assetTitle: {validateOk: true},
                        brandName: {validateOk: true},
                        theUnit: {validateOk: true},
                        model: {validateOk: true},
                        fixedSpec: {validateOk: true},
                        bizAreaName: {validateOk: true},
                        bizAreaCode: {validateOk: true},
                        price: {validateOk: true},
                        wrntPeriod: {validateOk: true},
                        bizFormNames: {validateOk: true}
                    };
                });
                //
                let feeItemImpInfos = el.feeItemImpInfos || [];
                feeItemImpInfos.forEach(function (subEel) {
                    subEel.validateInfo = {
                        htBh: {validateOk: true},
                        feeTypeText: {validateOk: true},
                        feeName: {validateOk: true},
                        feeBrandName: {validateOk: true},
                        feeModelSpec: {validateOk: true},
                        feeUnit: {validateOk: true},
                        feePrice: {validateOk: true},
                    };
                });
                //
                let sndPartyId = el.sndPartyId;
                if (!Utils.isNoB(sndPartyId)) {
                    let vendor = {
                        id: sndPartyId
                    };
                    self.getInvoiceContentTagList(el, vendor);
                }
            });
            this.contractImpDto.impInfoList = contractImpInfoList;
            //
            this.pageSize = this.pageSizes.first();
            self.checkData(true);
            self.setPageContractImpInfoList();
            this.getCurrUserInfo();
            theLoading.close();
            this.getCurrentUserInfo();
        },
        methods: {
            viewFieldFlag(name, ignoreBase, custFileds, fieldMap) {
                let custFlag = true;
                if (!Utils.isNoB(custFileds) && custFileds.length > 0) {
                    custFlag = this.custFileds.indexOf(name) > -1;
                }
                //
                let baseFlag = fieldMap[name] != null;
                if (Utils.isTrue(ignoreBase)) {
                    baseFlag = true;
                }
                return custFlag && baseFlag;
            },
            getFieldTitle(name, defTitle, fieldMap) {
                return fieldMap[name] != null ? fieldMap[name].title : defTitle;
            },
            getComnXportConfByUsage(usage) {
                let self = this;
                let theLoading = MsgBox.loading();
                comnApi.getComnXportConfByUsage({usage: usage}, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        let comnXportConf = result.data;
                        //
                        let sheetList = comnXportConf.sheetList;
                        sheetList.forEach(function (sheet) {
                            let fieldList = sheet.fieldList;
                            if (sheet.name == '合同基本信息') {
                                self.contractFieldMap = fieldList.toMap('name');
                            }
                            if (sheet.name == '资产信息') {
                                self.assetFieldMap = fieldList.toMap('name');
                            }
                            if (sheet.name == '组装件信息') {
                                self.asmblFieldMap = fieldList.toMap('name');
                            }
                            if (sheet.name == '费用项目') {
                                self.feeFieldMap = fieldList.toMap('name');
                            }
                        });
                        self.getMerchtImpTplDlInfo(usage);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getMerchtImpTplDlInfo(tplUsage) {
                let self = this;
                let theLoading = MsgBox.loading();
                merchtComnApi.getMerchtImpTplDlInfo({tplUsage: tplUsage}, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        let merchtImpTplDlInfo = result.data;
                        if (!Utils.isNoB(merchtImpTplDlInfo.tplConfig)) {
                            let custFiledMap = JSON.decode(merchtImpTplDlInfo.tplConfig);
                            self.contractCustFileds = custFiledMap['合同基本信息'];
                            self.assetCustFileds = custFiledMap['资产信息'];
                            self.asmblCustFileds = custFiledMap['组装件信息'];
                            self.feeCustFileds = custFiledMap['费用项目'];
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                    self.showTable = true;
                });
            },
            getCurrentUserInfo: function () {
                let self = this;
                let postData = {};
                userApi.getUserInfoByContext(postData, function (result) {
                    if (result.type == "info") {
                        self.fstPartyId = result.data.scopeEntity.id;
                        self.fstPartyType = result.data.scopeEntity.type;
                    }
                });
            },
            showManageDetail(row) {
                let rowNo = row.rowNo;
                let expends = this.expends || [];
                if (expends.indexOf(rowNo) > -1) {
                    expends.remove(rowNo);
                } else {
                    expends.push(rowNo);
                }
                this.expends = Utils.merge([], expends);
            },
            getRowKeys(row) {
                return row.rowNo;
            },
            getRowClass(dataRow) {
                let rowIndex = dataRow.rowIndex;
                let row = dataRow.row || {};
                let subImpInfos = row.subImpInfos || [];
                if (subImpInfos.length == 0) {  //判断当前行是否有子数据或者根据实际情况设置
                    return 'row-expand-cover'
                }
            },
            getCurrUserInfo() {
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if (result.type == 'info') {
                        let scopeEntity = result.data.scopeEntity;
                        self.scopeId = scopeEntity.scopeId;
                    }
                });
            },
            recalcTableHeight() {
                this.tableHeight = this.rootHeight - 60 - 42;
            },
            // 选中行
            markSelectedRowClassName(row) {
                return this.multipleSelection.find(function (tmpRow) {
                    return tmpRow.rowNo == row.rowNo;
                }) != null ? 'selected-row' : '';
            },
            //自动合并数据行
            commonChangeEvent() {
                this.checkData(false);
            },
            // 供应商信息变化事件
            vendorChangeEvent: function (row) {
                let self = this;
                let sndPartyNo = row.sndPartyNo;
                if (!Utils.isNoB(sndPartyNo)) {
                    let params = {
                        socialCreditCode: sndPartyNo
                    };
                    vendorApi.getVendorBySocialCreditCode(params, function (result) {
                        if (result.type == 'info') {
                            let vendor = result.data || {};
                            if (Utils.isNoB(vendor.id)) {
                                row.validateInfo.sndPartyName = {
                                    validateOk: false,
                                    errorMsg: "根据[供应商统一社会信用代码]未找到对应的供应商信息"
                                };
                                row.validateInfo.sndPartyNo = {
                                    validateOk: false,
                                    errorMsg: "根据[供应商统一社会信用代码]未找到对应的供应商信息"
                                };
                                row.failed = true;
                            } else {
                                row.sndPartyName = vendor.name;
                                row.validateInfo.sndPartyName = {
                                    validateOk: true
                                };
                                row.validateInfo.sndPartyNo = {
                                    validateOk: true
                                };
                                row.sndPartyId = vendor.id;
                                //
                                self.getInvoiceContentTagList(row, vendor);
                            }
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }
            },
            // 发票变化事件
            invoiceTypeChange: function (row) {
                let invoiceTypeMaps = this.invoiceTypeMaps || {};
                row.invoiceTypeText = invoiceTypeMaps[row.invoiceType];
                //
                if (!Utils.isNoB(row.invoiceType) && !Utils.isNoB(row.fstPartyRealComId)) {
                    this.getTaxOffSetVal(row);
                }
            },
            getInvoiceContentTagList: function (row, vendor) {
                let self = this;
                let postData = {};
                postData.merchantId = vendor.id;
                postData.merchantType = getEnumInfoWith("merchantType", "name", "Vendor").value;
                merchtFinacApi.getMerchantInvoiceCtntTagList(postData, function (result) {
                    if (result.type == 'info') {
                        if (result.data != null && result.data.length > 0) {
                            let invoiceContentTagList = result.data;
                            for (let i = 0; i < invoiceContentTagList.length; i++) {
                                let invoiceContentTag = invoiceContentTagList[i];
                                if (Utils.isTrue(invoiceContentTag.defaulted) && Utils.isNoB(row.invoiceContentTag)) {
                                    row.invoiceContentTag = invoiceContentTag.name;
                                }
                            }
                            self.invoiceContentTagList = Utils.merge([], invoiceContentTagList);
                        } else {
                            row.invoiceContentTag = null;
                            self.invoiceContentTagList = [];
                        }
                    }
                });
            },
            getTaxOffSetVal: function (row) {
                let self = this;
                let params = {
                    invoiceType: row.invoiceType,
                    realComId: row.fstPartyRealComId
                };
                merchtComnApi.getTaxDeductible(params, function (result) {
                    if (result.type == 'info') {
                        let data = result.data;
                        //
                        row.taxOffset = Utils.isTrue(data);
                    }
                });
            },
            // 资产信息变化事件
            assetChangeEvent: function (row) {
                let innerCode = row.innerCode;
                if (!Utils.isNoB(innerCode)) {
                    let params = {
                        innerCode: innerCode
                    };
                    devcDefApi.getMerchtDevcDefInfoByInnerCode(params, function (result) {
                        if (result.type == 'info') {
                            let devcDef = result.data || {};
                            if (Utils.isNoB(devcDef.id)) {
                                row.validateInfo.innerCode = {
                                    validateOk: false,
                                    errorMsg: "根据[资产定义编码]未找到对应的资产信息"
                                };
                                row.failed = true;
                            } else {
                                row.name = devcDef.name;
                                row.assetTitle = devcDef.title;
                                row.innerDevcCode = devcDef.innerDevcCode;
                                row.brandId = devcDef.brandId;
                                row.brandName = devcDef.brandName;
                                row.theUnit = devcDef.theUnit;
                                row.model = devcDef.model;
                                row.fixedSpec = devcDef.fixedSpec;
                            }
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }
            },
            // 组装件信息变化事件
            asmblChangeEvent: function (row) {
                let innerCode = row.innerCode;
                if (!Utils.isNoB(innerCode)) {
                    let params = {
                        innerCode: innerCode
                    };
                    asmblAccApi.getAsmblAccDefByUK2(params, function (result) {
                        if (result.type == 'info') {
                            let asmblAccDef = result.data || {};
                            if (Utils.isNoB(asmblAccDef.id)) {
                                row.validateInfo.innerCode = {
                                    validateOk: false,
                                    errorMsg: "根据[组装件定义编码]未找到对应的组装件信息"
                                };
                                row.failed = true;
                            } else {
                                row.name = asmblAccDef.name;
                                row.assetTitle = asmblAccDef.title;
                                row.brandName = asmblAccDef.brandName;
                                row.theUnit = asmblAccDef.theUnit;
                                row.model = asmblAccDef.model;
                                row.fixedSpec = asmblAccDef.fixedSpec;
                            }
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }
            },
            // 经营区域变化事件
            bizAreaChangeEvent: function (row) {
                let bizAreaCode = row.bizAreaCode;
                if (!Utils.isNoB(bizAreaCode)) {
                    let params = {
                        code: bizAreaCode
                    };
                    bizAreaApi.getRetailerBizAreaByCode(params, function (result) {
                        if (result.type == 'info') {
                            let bizArea = result.data || {};
                            if (Utils.isNoB(bizArea.id)) {
                                row.validateInfo.bizAreaCode = {
                                    validateOk: false,
                                    errorMsg: "未找到[区域编码]对应的经营区域，请先维护经营区域"
                                };
                                row.validateInfo.bizAreaName = {
                                    validateOk: false,
                                    errorMsg: "未找到[区域编码]对应的经营区域，请先维护经营区域"
                                };
                                row.failed = true;
                            } else if (!Utils.isNoB(bizArea.id) && !Utils.isNoB(row.bizAreaName) && bizArea.name != row.bizAreaName) {
                                row.validateInfo.bizAreaCode = {
                                    validateOk: false,
                                    errorMsg: "[区域编码]对应的经营区域的区域名称与输入的区域名称不符"
                                };
                                row.validateInfo.bizAreaName = {
                                    validateOk: false,
                                    errorMsg: "[区域编码]对应的经营区域的区域名称与输入的区域名称不符"
                                };
                                row.failed = true;
                            } else if (!Utils.isNoB(bizArea.id) && !Utils.isNoB(row.bizAreaName) && bizArea.name == row.bizAreaName) {
                                row.validateInfo.bizAreaCode = {
                                    validateOk: true
                                };
                                row.validateInfo.bizAreaName = {
                                    validateOk: true
                                };
                            }
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }
            },
            //
            checkData(firstFlag) {
                let self = this;
                let rows = this.contractImpDto.impInfoList.clone();
                let itemLength = rows.length;
                let byItemFlag = itemLength > 500;
                let htBhMap = {};
                for (let i = 0; i < rows.length; i++) {
                    let contractImpDto = rows[i];
                    contractImpDto.validateInfo = {
                        title: {validateOk: true},
                        htBh: {validateOk: true},
                        fstPartyRealComName: {validateOk: true},
                        sndPartyRealComName: {validateOk: true},
                        sndPartyName: {validateOk: true},
                        sndPartyNo: {validateOk: true},
                        dateStart: {validateOk: true},
                        dateEnd: {validateOk: true},
                        signDate: {validateOk: true},
                        desireArriveDays: {validateOk: true},
                        taxRate: {validateOk: true},
                        invoiceTypeText: {validateOk: true},
                        invoiceTitle: {validateOk: true},
                        invoiceContentTag: {validateOk: true},
                        taxPayerNo: {validateOk: true},
                        signGroupName: {validateOk: true}
                    };
                    let subImpInfos = contractImpDto.subImpInfos || [];
                    subImpInfos.forEach(function (subEel) {
                        subEel.validateInfo = {
                            htBh: {validateOk: true},
                            skuId: {validateOk: true},
                            goodsTitle: {validateOk: true},
                            innerCode: {validateOk: true},
                            name: {validateOk: true},
                            assetTitle: {validateOk: true},
                            innerDevcCode: {validateOk: true},
                            brandName: {validateOk: true},
                            theUnit: {validateOk: true},
                            model: {validateOk: true},
                            fixedSpec: {validateOk: true},
                            bizAreaName: {validateOk: true},
                            bizAreaCode: {validateOk: true},
                            price: {validateOk: true},
                            wrntPeriod: {validateOk: true},
                            bizFormNames: {validateOk: true}
                        };
                    });
                    let asmblImpInfos = contractImpDto.asmblImpInfos || [];
                    asmblImpInfos.forEach(function (subEel) {
                        subEel.validateInfo = {
                            htBh: {validateOk: true},
                            skuId: {validateOk: true},
                            goodsTitle: {validateOk: true},
                            innerCode: {validateOk: true},
                            name: {validateOk: true},
                            assetTitle: {validateOk: true},
                            brandName: {validateOk: true},
                            theUnit: {validateOk: true},
                            model: {validateOk: true},
                            fixedSpec: {validateOk: true},
                            bizAreaName: {validateOk: true},
                            bizAreaCode: {validateOk: true},
                            price: {validateOk: true},
                            wrntPeriod: {validateOk: true},
                            bizFormNames: {validateOk: true}
                        };
                    });
                    let feeItemImpInfos = contractImpDto.feeItemImpInfos || [];
                    feeItemImpInfos.forEach(function (subEel) {
                        subEel.validateInfo = {
                            htBh: {validateOk: true},
                            feeTypeText: {validateOk: true},
                            feeName: {validateOk: true},
                            feeBrandName: {validateOk: true},
                            feeModelSpec: {validateOk: true},
                            feeUnit: {validateOk: true},
                            feePrice: {validateOk: true},
                        };
                    });
                    // 校验合同基本信息
                    if (!Utils.isTrue(contractImpDto.virtualRow) && !Utils.isTrue(contractImpDto.subRow)) {
                        // 检查 [合同名称]
                        if (!Utils.isNoB(contractImpDto.title)) {
                            contractImpDto.title = this.replaceSL(contractImpDto.title, ' ');
                        } else if (!Utils.isNoB(contractImpDto.title) && contractImpDto.title.length > 60) {
                            contractImpDto.validateInfo.title = {
                                validateOk: false,
                                errorMsg: "[合同名称]单元长度最大60，当前[" + contractImpDto.title.length + "]"
                            };
                        } else if (Utils.isNoB(contractImpDto.title)) {
                            contractImpDto.validateInfo.title = {
                                validateOk: false,
                                errorMsg: "[合同名称]单元不可为空"
                            };
                        }
                        // 检查 [合同编号]
                        if (!Utils.isNoB(contractImpDto.htBh)) {
                            contractImpDto.htBh = this.replaceSL(contractImpDto.htBh, ' ');
                        } else if (!Utils.isNoB(contractImpDto.htBh) && contractImpDto.htBh.length > 30) {
                            contractImpDto.validateInfo.htBh = {
                                validateOk: false,
                                errorMsg: "[合同编号]单元长度最大30，当前[" + contractImpDto.htBh.length + "]"
                            };
                        } else if (Utils.isNoB(contractImpDto.htBh)) {
                            contractImpDto.validateInfo.htBh = {
                                validateOk: false,
                                errorMsg: "[合同编号]单元不可为空"
                            };
                        } else {
                            if (!Utils.isNoB(contractImpDto.htBh)) {
                                let mapVal = htBhMap[contractImpDto.htBh];
                                if (Utils.isNoB(mapVal)) {
                                    htBhMap[contractImpDto.htBh] = i;
                                } else {
                                    if (i != mapVal) {
                                        let row = rows[mapVal];
                                        if (row.htBh == contractImpDto.htBh) {
                                            let errMsg = "源件行号【" + contractImpDto.rowNo + "】与行号【" + row.rowNo + "】的【合同编号】不能相同，请修改";
                                            let errMsgOld = "源件行号【" + row.rowNo + "】与行号【" + contractImpDto.rowNo + "】的【合同编号】不能相同，请修改";
                                            contractImpDto.validateInfo.htBh = {
                                                validateOk: false,
                                                errorMsg: errMsg
                                            };
                                            row.validateInfo.htBh = {
                                                validateOk: false,
                                                errorMsg: errMsgOld
                                            };
                                            contractImpDto.failed = true;
                                            contractImpDto.failDesc = Utils.isNoB(contractImpDto.failDesc) ? errMsg : contractImpDto.failDesc.indexOf("【商品型号】") > -1 ? contractImpDto.failDesc : (contractImpDto.failDesc + '；' + errMsg);
                                            row.failed = true;
                                            row.failDesc = Utils.isNoB(row.failDesc) ? errMsgOld : row.failDesc.indexOf("【商品型号】") > -1 ? row.failDesc : (row.failDesc + '；' + errMsgOld);
                                        } else {
                                            let errMsg = "源件行号【" + contractImpDto.rowNo + "】与行号【" + row.rowNo + "】的【合同编号】不能相同，请修改";
                                            let errMsgOld = "源件行号【" + row.rowNo + "】与行号【" + contractImpDto.rowNo + "】的【合同编号】不能相同，请修改";
                                            if (!Utils.isNoB(contractImpDto.failDesc) && contractImpDto.failDesc.indexOf(errMsg) > -1) {
                                                contractImpDto.failDesc = contractImpDto.failDesc.replace(errMsg, '');
                                            } else if (!Utils.isNoB(contractImpDto.failDesc) && contractImpDto.failDesc.indexOf('；' + errMsg) > -1) {
                                                contractImpDto.failDesc = contractImpDto.failDesc.replace('；' + errMsg, '');
                                            }
                                            if (!Utils.isNoB(row.failDesc) && row.failDesc.indexOf(errMsgOld) > -1) {
                                                row.failDesc = row.failDesc.replace(errMsgOld, '');
                                            } else if (!Utils.isNoB(row.failDesc) && row.failDesc.indexOf('；' + errMsgOld) > -1) {
                                                row.failDesc = row.failDesc.replace('；' + errMsgOld, '');
                                            }
                                            if (Utils.isNoB(contractImpDto.failDesc)) {
                                                contractImpDto.failed = false;
                                            }
                                            if (Utils.isNoB(row.failDesc)) {
                                                row.failed = false;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        if (Utils.isNoB(contractImpDto.fstPartyRealComName)) {
                            contractImpDto.validateInfo.fstPartyRealComName = {
                                validateOk: false,
                                errorMsg: "[买方公司]单元不可为空"
                            };
                        }
                        if (Utils.isNoB(contractImpDto.sndPartyRealComName)) {
                            contractImpDto.validateInfo.sndPartyRealComName = {
                                validateOk: false,
                                errorMsg: "[卖方公司]单元不可为空"
                            };
                        }
                        // 检查 [供应商名称]
                        if (!Utils.isNoB(contractImpDto.sndPartyName)) {
                            contractImpDto.sndPartyName = this.replaceSL(contractImpDto.sndPartyName, ' ');
                        } else if (!Utils.isNoB(contractImpDto.sndPartyName) && contractImpDto.sndPartyName.length > 60) {
                            contractImpDto.validateInfo.sndPartyName = {
                                validateOk: false,
                                errorMsg: "[供应商名称]单元长度最大60，当前[" + contractImpDto.sndPartyName.length + "]"
                            };
                        } else if (Utils.isNoB(contractImpDto.sndPartyName)) {
                            contractImpDto.validateInfo.sndPartyName = {
                                validateOk: false,
                                errorMsg: "[供应商名称]单元不可为空"
                            };
                        }
                        // 检查 [供应商统一社会信用代码]
                        if (!Utils.isNoB(contractImpDto.sndPartyNo)) {
                            contractImpDto.sndPartyNo = this.replaceSL(contractImpDto.sndPartyNo, ' ');
                        } else if (Utils.isNoB(contractImpDto.sndPartyNo)) {
                            contractImpDto.validateInfo.sndPartyNo = {
                                validateOk: false,
                                errorMsg: "[供应商统一社会信用代码]单元不可为空"
                            };
                        }
                        // 检查 [开始时间]
                        if (!Utils.isNoB(contractImpDto.dateStart)) {
                            if (!Utils.isNoB(contractImpDto.dateEnd)) {
                                let dateStartStr = new Date(contractImpDto.dateStart).format("yyyy-MM-dd");
                                let dateEndStr = new Date(contractImpDto.dateEnd).format("yyyy-MM-dd");
                                if (dateStartStr == dateEndStr) {
                                    contractImpDto.validateInfo.dateStart = {
                                        validateOk: false,
                                        errorMsg: "开始时间不能与结束时间相同"
                                    };
                                    contractImpDto.validateInfo.dateEnd = {
                                        validateOk: false,
                                        errorMsg: "结束时间不能与开始时间相同"
                                    };
                                } else if (contractImpDto.dateStart > contractImpDto.dateEnd) {
                                    contractImpDto.validateInfo.dateStart = {
                                        validateOk: false,
                                        errorMsg: "开始时间不能晚于结束时间"
                                    };
                                    contractImpDto.validateInfo.dateEnd = {
                                        validateOk: false,
                                        errorMsg: "结束时间不能早于开始时间"
                                    };
                                }
                            }
                        } else {
                            contractImpDto.validateInfo.dateStart = {
                                validateOk: false,
                                errorMsg: "[开始时间]单元不可为空"
                            };
                        }
                        // 检查 [结束时间]
                        if (!Utils.isNoB(contractImpDto.dateEnd)) {
                            if (!Utils.isNoB(contractImpDto.dateStart)) {
                                let dateStartStr = new Date(contractImpDto.dateStart).format("yyyy-MM-dd");
                                let dateEndStr = new Date(contractImpDto.dateEnd).format("yyyy-MM-dd");
                                if (dateStartStr == dateEndStr) {
                                    contractImpDto.validateInfo.dateStart = {
                                        validateOk: false,
                                        errorMsg: "开始时间不能与结束时间相同"
                                    };
                                    contractImpDto.validateInfo.dateEnd = {
                                        validateOk: false,
                                        errorMsg: "结束时间不能与开始时间相同"
                                    };
                                } else if (contractImpDto.dateStart > contractImpDto.dateEnd) {
                                    contractImpDto.validateInfo.dateStart = {
                                        validateOk: false,
                                        errorMsg: "开始时间不能晚于结束时间"
                                    };
                                    contractImpDto.validateInfo.dateEnd = {
                                        validateOk: false,
                                        errorMsg: "结束时间不能早于开始时间"
                                    };
                                }
                            }
                        } else {
                            contractImpDto.validateInfo.dateEnd = {
                                validateOk: false,
                                errorMsg: "[结束时间]单元不可为空"
                            };
                        }
                        // 检查 [签署日期]
                        if (!Utils.isNoB(contractImpDto.signDate)) {
                            if (!Utils.isNoB(contractImpDto.signDate)) {
                                if (contractImpDto.dateStart < contractImpDto.signDate) {
                                    contractImpDto.validateInfo.dateStart = {
                                        validateOk: false,
                                        errorMsg: "开始时间不能早于签署日期"
                                    };
                                    contractImpDto.validateInfo.signDate = {
                                        validateOk: false,
                                        errorMsg: "签署日期不能晚于开始时间"
                                    };
                                }
                            }
                        } else {
                            contractImpDto.validateInfo.signDate = {
                                validateOk: false,
                                errorMsg: "[签署日期]单元不可为空"
                            };
                        }
                        // 检查[到货期限（天）]
                        if (!Utils.isNoB(contractImpDto.desireArriveDays) && parseInt(contractImpDto.desireArriveDays) < 0) {
                            contractImpDto.validateInfo.desireArriveDays = {
                                validateOk: false,
                                errorMsg: "[到货期限（天）]单元请填写正确天数"
                            };
                        }
                        // 检查 [税率(%)]
                        if (!Utils.isNoB(contractImpDto.taxRate)) {
                            if (!Utils.isMoneyStr(contractImpDto.taxRate)) {
                                contractImpDto.validateInfo.taxRate = {
                                    validateOk: false,
                                    errorMsg: "[税率(%)]单元格式不对，税率为大于等于0，小于100的数"
                                };
                            } else if (contractImpDto.taxRate > 100) {
                                contractImpDto.validateInfo.taxRate = {
                                    validateOk: false,
                                    errorMsg: "[税率(%)]单元中的值不能超过100"
                                };
                            } else {
                                contractImpDto.taxRate = parseFloat(contractImpDto.taxRate).toFixed(2);
                            }
                        } else {
                            contractImpDto.validateInfo.taxRate = {
                                validateOk: false,
                                errorMsg: "[税率(%)]单元不可为空"
                            };
                        }
                    }

                    // 校验合同资产信息
                    for (let j = 0; j < subImpInfos.length; j++) {
                        let subInfo = subImpInfos[j];
                        // 检查 [合同编号]
                        if (!Utils.isNoB(subInfo.htBh)) {
                            subInfo.htBh = this.replaceSL(subInfo.htBh, ' ');
                        } else if (!Utils.isNoB(subInfo.htBh) && subInfo.htBh.length > 30) {
                            subInfo.validateInfo.htBh = {
                                validateOk: false,
                                errorMsg: "[合同编号]单元长度最大30，当前[" + subInfo.htBh.length + "]"
                            };
                        } else if (Utils.isNoB(subInfo.htBh)) {
                            subInfo.validateInfo.htBh = {
                                validateOk: false,
                                errorMsg: "[合同编号]单元不可为空"
                            };
                        }
                        if (self.usage == "contract.by.goods.import") {
                            // 检查 [SKUID]
                            if (Utils.isNoB(subInfo.skuId) || subInfo.skuId <= 0) {
                                subInfo.validateInfo.skuId = {
                                    validateOk: false,
                                    errorMsg: "[SKUID]单元不可为空"
                                };
                            }
                            // 检查 [商品名称]
                            if (!Utils.isNoB(subInfo.goodsTitle)) {
                                subInfo.goodsTitle = this.replaceSL(subInfo.goodsTitle, ' ');
                            } else {
                                subInfo.validateInfo.goodsTitle = {
                                    validateOk: false,
                                    errorMsg: "[商品名称]单元不可为空"
                                };
                            }
                        } else {
                            // 检查 [资产定义编码]
                            if (!Utils.isNoB(subInfo.innerCode)) {
                                subInfo.innerCode = this.replaceSL(subInfo.innerCode, ' ');
                            } else {
                                subInfo.validateInfo.innerCode = {
                                    validateOk: false,
                                    errorMsg: "[资产定义编码]单元不可为空"
                                };
                            }
                            // 检查 [资产名称]
                            if (!Utils.isNoB(subInfo.name)) {
                                subInfo.name = this.replaceSL(subInfo.name, ' ');
                            } else {
                                subInfo.validateInfo.name = {
                                    validateOk: false,
                                    errorMsg: "[资产名称]单元不可为空"
                                };
                            }
                            // 检查 [资产描述全称]
                            if (!Utils.isNoB(subInfo.assetTitle)) {
                                subInfo.assetTitle = this.replaceSL(subInfo.assetTitle, ' ');
                            } else {
                                subInfo.validateInfo.assetTitle = {
                                    validateOk: false,
                                    errorMsg: "[资产描述全称]单元不可为空"
                                };
                            }
                        }
                        // 经营区域
                        if (!Utils.isNoB(subInfo.bizAreaName) && Utils.isNoB(subInfo.bizAreaCode)) {
                            subInfo.validateInfo.bizAreaCode = {
                                validateOk: false,
                                errorMsg: "[区域编码]单元不能为空"
                            };
                        }
                        if (!Utils.isNoB(subInfo.bizAreaCode) && !Utils.isNoB(contractImpDto.failDesc)) {
                            let bizAreaMsg = "未找到[区域编码]对应的经营区域，请先维护经营区域";
                            let bizAreaMsg1 = "[区域编码]对应的经营区域的区域名称与输入的区域名称不符";
                            if (contractImpDto.failDesc.indexOf(bizAreaMsg) > -1) {
                                subInfo.validateInfo.bizAreaName = {
                                    validateOk: false,
                                    errorMsg: bizAreaMsg
                                };
                                subInfo.validateInfo.bizAreaCode = {
                                    validateOk: false,
                                    errorMsg: bizAreaMsg
                                };
                            }
                            if (contractImpDto.failDesc.indexOf(bizAreaMsg1) > -1) {
                                subInfo.validateInfo.bizAreaName = {
                                    validateOk: false,
                                    errorMsg: bizAreaMsg1
                                };
                                subInfo.validateInfo.bizAreaCode = {
                                    validateOk: false,
                                    errorMsg: bizAreaMsg1
                                };
                            }
                        }
                        // 检查修正 [含税价(元)]
                        if (!Utils.isNoB(subInfo.price)) {
                            if (!Utils.isMoneyStr(subInfo.price) || subInfo.price <= 0) {
                                subInfo.validateInfo.price = {
                                    validateOk: false,
                                    errorMsg: "[含税价(元)]单元为 > 0 的数"
                                };
                            } else {
                                subInfo.price = parseFloat(subInfo.price).toFixed(2);
                            }
                        } else {
                            subInfo.validateInfo.price = {
                                validateOk: false,
                                errorMsg: "[含税价(元)]单元不可为空"
                            };
                        }
                        // 检查修正 [质保期(月)]
                        if (!Utils.isNoB(subInfo.wrntPeriod)) {
                            if (!Utils.isNaturalStr(subInfo.wrntPeriod) || subInfo.wrntPeriod <= 0) {
                                subInfo.validateInfo.wrntPeriod = {
                                    validateOk: false,
                                    errorMsg: "[质保期(月)]单元为 > 0 的整数"
                                };
                            }
                        } else {
                            subInfo.validateInfo.wrntPeriod = {
                                validateOk: false,
                                errorMsg: "[质保期(月)]单元不可为空"
                            };
                        }
                        if (!Utils.isNoB(subInfo.bizFormNames) && !Utils.isNoB(contractImpDto.failDesc)) {
                            let errMsg = "[经营业态]单元最多可设置5个，用'|'分割";
                            let errMsg2 = "未找到经营业态为";
                            if (contractImpDto.failDesc.indexOf(errMsg) > -1) {
                                subInfo.validateInfo.bizFormNames = {
                                    validateOk: false,
                                    errorMsg: errMsg
                                };
                            } else if (contractImpDto.failDesc.indexOf(errMsg2) > -1) {
                                subInfo.validateInfo.bizFormNames = {
                                    validateOk: false,
                                    errorMsg: "有未找到的经营业态，请先维护业态信息"
                                };
                            }
                        }
                    }
                    //
                    contractImpDto.subImpInfos = Utils.merge([], subImpInfos);
                    // 校验合同组装件信息
                    for (let j = 0; j < asmblImpInfos.length; j++) {
                        let subInfo = asmblImpInfos[j];
                        // 检查 [合同编号]
                        if (!Utils.isNoB(subInfo.htBh)) {
                            subInfo.htBh = this.replaceSL(subInfo.htBh, ' ');
                        } else if (!Utils.isNoB(subInfo.htBh) && subInfo.htBh.length > 30) {
                            subInfo.validateInfo.htBh = {
                                validateOk: false,
                                errorMsg: "[合同编号]单元长度最大30，当前[" + subInfo.htBh.length + "]"
                            };
                        } else if (Utils.isNoB(subInfo.htBh)) {
                            subInfo.validateInfo.htBh = {
                                validateOk: false,
                                errorMsg: "[合同编号]单元不可为空"
                            };
                        }
                        if (self.usage == "contract.by.goods.import") {
                            // 检查 [SKUID]
                            if (Utils.isNoB(subInfo.skuId) || subInfo.skuId <= 0) {
                                subInfo.validateInfo.skuId = {
                                    validateOk: false,
                                    errorMsg: "[SKUID]单元不可为空"
                                };
                            }
                            // 检查 [商品名称]
                            if (!Utils.isNoB(subInfo.goodsTitle)) {
                                subInfo.goodsTitle = this.replaceSL(subInfo.goodsTitle, ' ');
                            } else {
                                subInfo.validateInfo.goodsTitle = {
                                    validateOk: false,
                                    errorMsg: "[商品名称]单元不可为空"
                                };
                            }
                        } else {
                            // 检查 [资产定义编码]
                            if (!Utils.isNoB(subInfo.innerCode)) {
                                subInfo.innerCode = this.replaceSL(subInfo.innerCode, ' ');
                            } else {
                                subInfo.validateInfo.innerCode = {
                                    validateOk: false,
                                    errorMsg: "[组装件定义编码]单元不可为空"
                                };
                            }
                            // 检查 [资产名称]
                            if (!Utils.isNoB(subInfo.name)) {
                                subInfo.name = this.replaceSL(subInfo.name, ' ');
                            } else {
                                subInfo.validateInfo.name = {
                                    validateOk: false,
                                    errorMsg: "[组装件名称]单元不可为空"
                                };
                            }
                            // 检查 [资产描述全称]
                            if (!Utils.isNoB(subInfo.assetTitle)) {
                                subInfo.assetTitle = this.replaceSL(subInfo.assetTitle, ' ');
                            } else {
                                subInfo.validateInfo.assetTitle = {
                                    validateOk: false,
                                    errorMsg: "[组装件描述全称]单元不可为空"
                                };
                            }
                        }
                        // 经营区域
                        if (!Utils.isNoB(subInfo.bizAreaName) && Utils.isNoB(subInfo.bizAreaCode)) {
                            subInfo.validateInfo.bizAreaCode = {
                                validateOk: false,
                                errorMsg: "[区域编码]单元不能为空"
                            };
                        }
                        if (!Utils.isNoB(subInfo.bizAreaCode) && !Utils.isNoB(contractImpDto.failDesc)) {
                            let bizAreaMsg = "未找到[区域编码]对应的经营区域，请先维护经营区域";
                            let bizAreaMsg1 = "[区域编码]对应的经营区域的区域名称与输入的区域名称不符";
                            if (contractImpDto.failDesc.indexOf(bizAreaMsg) > -1) {
                                subInfo.validateInfo.bizAreaName = {
                                    validateOk: false,
                                    errorMsg: bizAreaMsg
                                };
                                subInfo.validateInfo.bizAreaCode = {
                                    validateOk: false,
                                    errorMsg: bizAreaMsg
                                };
                            }
                            if (contractImpDto.failDesc.indexOf(bizAreaMsg1) > -1) {
                                subInfo.validateInfo.bizAreaName = {
                                    validateOk: false,
                                    errorMsg: bizAreaMsg1
                                };
                                subInfo.validateInfo.bizAreaCode = {
                                    validateOk: false,
                                    errorMsg: bizAreaMsg1
                                };
                            }
                        }
                        // 检查修正 [含税价(元)]
                        if (!Utils.isNoB(subInfo.price)) {
                            if (!Utils.isMoneyStr(subInfo.price) || subInfo.price <= 0) {
                                subInfo.validateInfo.price = {
                                    validateOk: false,
                                    errorMsg: "[含税价(元)]单元为 > 0 的数"
                                };
                            } else {
                                subInfo.price = parseFloat(subInfo.price).toFixed(2);
                            }
                        } else {
                            subInfo.validateInfo.price = {
                                validateOk: false,
                                errorMsg: "[含税价(元)]单元不可为空"
                            };
                        }
                        // 检查修正 [质保期(月)]
                        if (!Utils.isNoB(subInfo.wrntPeriod)) {
                            if (!Utils.isNaturalStr(subInfo.wrntPeriod) || subInfo.wrntPeriod <= 0) {
                                subInfo.validateInfo.wrntPeriod = {
                                    validateOk: false,
                                    errorMsg: "[质保期(月)]单元为 > 0 的整数"
                                };
                            }
                        } else {
                            subInfo.validateInfo.wrntPeriod = {
                                validateOk: false,
                                errorMsg: "[质保期(月)]单元不可为空"
                            };
                        }
                        if (!Utils.isNoB(subInfo.bizFormNames) && !Utils.isNoB(contractImpDto.failDesc)) {
                            let errMsg = "[经营业态]单元最多可设置5个，用'|'分割";
                            let errMsg2 = "未找到经营业态为";
                            if (contractImpDto.failDesc.indexOf(errMsg) > -1) {
                                subInfo.validateInfo.bizFormNames = {
                                    validateOk: false,
                                    errorMsg: errMsg
                                };
                            } else if (contractImpDto.failDesc.indexOf(errMsg2) > -1) {
                                subInfo.validateInfo.bizFormNames = {
                                    validateOk: false,
                                    errorMsg: "有未找到的经营业态，请先维护业态信息"
                                };
                            }
                        }
                    }
                    //
                    contractImpDto.asmblImpInfos = Utils.merge([], asmblImpInfos);
                    //
//                    if(!Utils.isTrue(firstFlag)) {
//                        let validatePass = true;
//                        let validateInfo = contractImpDto.validateInfo || {};
//                        if(Utils.isTrue(validateInfo.title.validateOk) && Utils.isTrue(validateInfo.htBh.validateOk) && Utils.isTrue(validateInfo.sndPartyName.validateOk) && Utils.isTrue(validateInfo.sndPartyNo.validateOk) //
//                            && Utils.isTrue(validateInfo.dateStart.validateOk) && Utils.isTrue(validateInfo.dateEnd.validateOk) && Utils.isTrue(validateInfo.signDate.validateOk) && Utils.isTrue(validateInfo.taxRate.validateOk)) {
//                            validatePass = true;
//                        } else {
//                            validatePass = false;
//                        }
//                        for(let j = 0; j < subImpInfos.length; j++) {
//                            let subInfo = subImpInfos[j];
//                            let subValidateInfo = subInfo.validateInfo || {};
//                            if(!(Utils.isTrue(subValidateInfo.htBh.validateOk) && Utils.isTrue(subValidateInfo.innerCode.validateOk) && Utils.isTrue(subValidateInfo.name.validateOk) && Utils.isTrue(subValidateInfo.innerDevcCode.validateOk) //
//                                && Utils.isTrue(subValidateInfo.brandName.validateOk) && Utils.isTrue(subValidateInfo.theUnit.validateOk) && Utils.isTrue(subValidateInfo.model.validateOk) && Utils.isTrue(subValidateInfo.fixedSpec.validateOk) //
//                                && Utils.isTrue(subValidateInfo.bizAreaName.validateOk) && Utils.isTrue(subValidateInfo.bizAreaCode.validateOk) && Utils.isTrue(subValidateInfo.price.validateOk) && Utils.isTrue(subValidateInfo.wrntPeriod.validateOk) //
//                                && Utils.isTrue(subValidateInfo.bizFormNames.validateOk) && Utils.isTrue(subValidateInfo.assetTitle.validateOk))) {
//                                validatePass = false;
//                            }
//                        }
//                        for(let j = 0; j < asmblImpInfos.length; j++) {
//                            let subInfo = asmblImpInfos[j];
//                            let subValidateInfo = subInfo.validateInfo || {};
//                            if(!(Utils.isTrue(subValidateInfo.htBh.validateOk) && Utils.isTrue(subValidateInfo.innerCode.validateOk) && Utils.isTrue(subValidateInfo.name.validateOk) //
//                                && Utils.isTrue(subValidateInfo.brandName.validateOk) && Utils.isTrue(subValidateInfo.theUnit.validateOk) && Utils.isTrue(subValidateInfo.model.validateOk) && Utils.isTrue(subValidateInfo.fixedSpec.validateOk) //
//                                && Utils.isTrue(subValidateInfo.bizAreaName.validateOk) && Utils.isTrue(subValidateInfo.bizAreaCode.validateOk) && Utils.isTrue(subValidateInfo.price.validateOk) && Utils.isTrue(subValidateInfo.wrntPeriod.validateOk) //
//                                && Utils.isTrue(subValidateInfo.bizFormNames.validateOk) && Utils.isTrue(subValidateInfo.assetTitle.validateOk))) {
//                                validatePass = false;
//                            }
//                        }
//                        if(Utils.isTrue(validatePass) && ) {
//                            contractImpDto.failed = false;
//                            contractImpDto.failDesc = null;
//                        } else {
//                            contractImpDto.failed = true;
//                        }
//                    }
                }
                //记录被选中的行
                let oldSelectedRowNos = this.multipleSelection.pluck('rowNo');
                let multipleSelectionMain = this.multipleSelectionMain.pluck('rowNo');
                //
                this.contractImpDto.impInfoList = rows;
                this.setPageContractImpInfoList();
                //（必须）延迟恢复被选中的行
                setTimeout(function () {
                    self.contractImpDto.impInfoList.forEach(function (row) {
                        if (oldSelectedRowNos.indexOf(row.rowNo) != -1) {
                            self.$refs.contractImpInfoTable.toggleRowSelection(row);
                        }
                    });
                }, 1000);
                setTimeout(function () {
                    self.contractImpDto.impInfoList.forEach(function (row) {
                        if (multipleSelectionMain.indexOf(row.rowNo) != -1) {
                            self.$refs.contractImpInfoTable.toggleRowSelection(row);
                        }
                    });
                }, 1000);
            },
            setPageContractImpInfoList: function () {
                let totalRows = this.contractImpDto.impInfoList;
                let start = (this.pageNumber - 1) * this.pageSize;
                let end = this.pageNumber * this.pageSize;
                let rows = totalRows.slice(start, end);
                let expends = this.expends || [];
                for (let i = 0; i < rows.length; i++) {
                    let row = rows[i];
                    let subImpInfos = row.subImpInfos || [];
                    if (subImpInfos.length > 0) {
                        if (!expends.contains(row.rowNo)) {
                            expends.push(row.rowNo);
                        }
                    }
                    let asmblImpInfos = row.asmblImpInfos || [];
                    if (asmblImpInfos.length > 0) {
                        if (!expends.contains(row.rowNo)) {
                            expends.push(row.rowNo);
                        }
                    }
                }
                this.expends = Utils.merge([], expends);
                this.pageContractImpList = rows;
                this.totalCount = totalRows.length;
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.setPageContractImpInfoList();
            },
            downloadContractImpModel: function () {
                contractApi.contractImpModelForExport(this.contractImpDto, function (result) {
                    if (result.type == 'info') {
                        Utils.downloadFile(getAppUrl(result.data));
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                return this.contractImpDto;
            },
            // 设置SKUID
            setGoods(h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if (self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行！");
                                    return;
                                }
                                let pageContractImpList = self.pageContractImpList || [];
                                let contractMap = pageContractImpList.toMap("htBh");
                                let contract = null;
                                let vendorId = null;
                                for (let i = 0; i < self.multipleSelection.length; i++) {
                                    let contractGoods = self.multipleSelection[i];
                                    contract = contractMap[contractGoods.htBh];
                                    if (contract != null) {
                                        vendorId = contract.sndPartyId;
                                        if (!Utils.isNoB(vendorId) && parseInt(vendorId) > 0) {
                                            break;
                                        }
                                    }
                                }
                                if (Utils.isNoB(vendorId) || parseInt(vendorId) <= 0) {
                                    MsgBox.warning("请先设置供应商信息");
                                    return;
                                }

                                let filter = {};
                                filter.merchantId = vendorId;
                                filter.merchantType = getEnumInfoWith("merchantType", "name", "Vendor").value;
                                filter.saleHalted = false;
                                openSkuListSelectDlg(false, filter, null, function (sku) {
                                    if (sku.goodsId != null && sku.title != null) {
                                        for (let i = 0; i < self.multipleSelection.length; i++) {
                                            self.multipleSelection[i].skuId = sku.id;
                                            self.multipleSelection[i].goodsTitle = sku.title || '' + sku.fixedSpec || '';
                                            if (self.usage == "contract.by.goods.import") {
                                                self.multipleSelection[i].model = sku.model;
                                                self.multipleSelection[i].fixedSpec = sku.fixedSpec;
                                                self.multipleSelection[i].brandId = sku.brandId;
                                                self.multipleSelection[i].brandName = sku.brandName;
                                                if (sku.priceNegoFlag) {
                                                    self.multipleSelection[i].price = null;
                                                } else {
                                                    self.multipleSelection[i].price = Utils.isNoB(sku.salePrice) ? null : parseFloat(sku.salePrice).toFixed(2);
                                                }
                                                self.multipleSelection[i].wrntPeriod = sku.wrntPeriod;
                                                self.multipleSelection[i].theUnit = sku.unit;
                                            }
                                        }
                                    }
                                    //
                                    self.checkData(false);
                                });
                            }
                        }
                    }, '设置'),
                ])
            },
            // 设置经营业态
            setBizFormNames(h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if (self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行！");
                                    return;
                                }
                                let params = {
                                    isShowSelection: true
                                };
                                openBizFormSelectionDlg(params, function (bizFormList, theDlg) {
                                    //
                                    bizFormList = bizFormList || [];
                                    if (bizFormList.length > 5) {
                                        MsgBox.warning("最多可设置5个经营业态！");
                                        return;
                                    }
                                    theDlg.close();
                                    let bizFormIds = '';
                                    let bizFormNames = '';
                                    for (let i = 0; i < bizFormList.length; i++) {
                                        let bizForm = bizFormList[i];
                                        if (bizFormIds.length <= 0) {
                                            bizFormIds = '|' + bizForm.id + '|';
                                            bizFormNames = bizForm.name;
                                        } else {
                                            bizFormIds += (bizForm.id + '|');
                                            bizFormNames += ('|' + bizForm.name);
                                        }
                                    }
                                    //
                                    for (let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].bizFormIds = bizFormIds;
                                        self.multipleSelection[i].bizFormNames = bizFormNames;
                                    }
                                    self.checkData(false);
                                });
                            }
                        }
                    }, '设置'),
                ])
            },
            // 设置买方公司
            setFstPartyRealComInfo(h) {
                let self = this;
                if (!Utils.isTrue(self.fileObj.extra.updateFlag)) {
                    return h('span', [
                        h('a', {
                            class: 'swb-btn swb-btn-link',
                            on: {
                                click: function () {
                                    if (self.multipleSelectionMain.length == 0) {
                                        self.$message.warning("请勾选要设置的行！");
                                        return;
                                    }
                                    selectMerchantRealComDlg({}, function (result) {
                                        for (let i = 0; i < self.multipleSelectionMain.length; i++) {
                                            self.multipleSelectionMain[i].fstPartyRealComId = result.id;
                                            self.multipleSelectionMain[i].fstPartyRealComName = result.name;
                                            self.multipleSelectionMain[i].fstPartyRealComCode = result.code;
                                        }
                                        self.checkData(false);
                                    });
                                }
                            }
                        }, '设置'),
                    ]);
                }
            },
            // 设置卖方公司
            setSndPartyRealComInfo(h) {
                let self = this;
                if (!Utils.isTrue(self.fileObj.extra.updateFlag)) {
                    return h('span', [
                        h('a', {
                            class: 'swb-btn swb-btn-link',
                            on: {
                                click: function () {
                                    let multipleSelectionMain = self.multipleSelectionMain || [];
                                    if (self.multipleSelectionMain.length == 0) {
                                        self.$message.warning("请勾选要设置的行！");
                                        return;
                                    }
                                    let vendorId = null;
                                    let vendorRealComId = null;
                                    let errorMsg = null;
                                    for (let i = 0; i < multipleSelectionMain.length; i++) {
                                        let itemInfo = multipleSelectionMain[i];
                                        vendorRealComId = itemInfo.sndPartyRealComId;
                                        if (vendorId == null) {
                                            vendorId = itemInfo.sndPartyId;
                                        } else if (vendorId != itemInfo.sndPartyId) {
                                            errorMsg = "请选择同供应商信息";
                                            break;
                                        }
                                    }
                                    if (!Utils.isNoB(errorMsg)) {
                                        self.$message.warning(errorMsg);
                                        return;
                                    }
                                    if (Utils.isNoB(vendorId)) {
                                        self.$message.warning("无供应商信息不可设置卖方公司");
                                        return;
                                    }
                                    // 选择入选供方公司
                                    selectRealAdoptedComDlg({
                                        checkBox: false,
                                        filter: {
                                            peerRealComId: vendorRealComId,
                                            peerMerchantType: getEnumInfoWith('merchantType', 'name', 'Vendor').value,
                                            adoptedType: 1 // 准入类型：入选
                                        }
                                    }, function (realAdoptedCom, theDlg) {
                                        theDlg.close();
                                        realAdoptedCom = realAdoptedCom || {};
                                        //
                                        for (let i = 0; i < self.multipleSelectionMain.length; i++) {
                                            self.multipleSelectionMain[i].sndPartyRealComId = realAdoptedCom.peerRealComId;
                                            self.multipleSelectionMain[i].sndPartyRealComName = realAdoptedCom.peerRealComName;
                                        }
                                        self.checkData(false);
                                    });
                                }
                            }
                        }, '设置'),
                    ]);
                }
            },
            // 选择行
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            handleMainSelectionChange(val) {
                this.multipleSelectionMain = val;
            },
            // 逐条检查
            validateContractImpModel: function (isFirst) {
                this.checkNextIndex = isFirst ? 0 : this.checkNextIndex;
                this.startFlag = true;
                let self = this;
                this.getDlgResult();
                let contractImpDto = this.contractImpDto;
                //
                let srcContractImpInfoList = contractImpDto.impInfoList || [];
                let srcListLength = srcContractImpInfoList.length;
                console.log(srcListLength);
                //
                let checkNextIndex = this.checkNextIndex;
                let srcImpInfo = srcContractImpInfoList[checkNextIndex];
                let postData = Utils.merge({}, contractImpDto);
                postData.impInfoList = [srcImpInfo];
                postData.updateFlag = self.fileObj.extra.updateFlag;
                let theLoading = MsgBox.loading("【源件行号：" + srcImpInfo.rowNo + "】正在处理，请稍后...");
                contractApi.validateContractImpModel(postData, function (result) {
                    theLoading.hide();
                    let callItem = result.data.impInfoList[0];
                    if (result.type == 'info') {
                        callItem.failed = false;
                        callItem.failDesc = null;
                    } else {
                        callItem.failed = true;
                        callItem.failDesc = result.message;
                    }
                    srcContractImpInfoList[checkNextIndex] = Utils.merge({}, callItem);
                    contractImpDto.srcContractImpInfoList = srcContractImpInfoList;
                    self.contractImpDto = Utils.merge({}, contractImpDto);
                    self.checkData(false);
                    //
                    let pageSize = self.pageSize;
                    let pageNumber = (checkNextIndex + 1) / pageSize;
                    let pageNumber2 = (checkNextIndex + 1) % pageSize;
                    if (pageNumber2 != 0) {
                        pageNumber = pageNumber + 1;
                    }
                    self.handlePageChange(pageNumber);
                    //
                    if (checkNextIndex < srcListLength - 1) {
                        self.checkNextIndex += 1;
                        self.validateContractImpModel(false);
                    } else {
                        self.handlePageChange(1);
                    }
                });
            },
            // 逐条检查导入
            doContractImpModelImport() {
                let self = this;
                this.getDlgResult();
                let contractImpDto = this.contractImpDto;
                // 判断全部的状态是否是ok
                let srcContractImpInfoList = contractImpDto.impInfoList || [];
                let srcListLength = srcContractImpInfoList.length;
                for (let i = 0; i < srcListLength; i++) {
                    let srcContractImpInfo = srcContractImpInfoList[i];
                    if (Utils.isTrue(srcContractImpInfo.failed)) {
                        MsgBox.warning("校验不通过，请修改导入数据！");
                        return;
                    }
                }
                //
                if (srcListLength > 500) {
                    //弹出确认框
                    this.$confirm('数据较多,将会执行一段时间,请勿关闭此页面或关闭浏览器,确定导入吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        self.doContractImpModelImportStart();
                    }).catch(function () {

                    });
                } else {
                    self.doContractImpModelImportStart();
                }
            },
            // 开始导入
            doContractImpModelImportStart() {
                this.startFlag = true;
                let contractImpDto = this.contractImpDto;
                //
                let impDto = {};
                impDto.merchantId = contractImpDto.merchantId;
                impDto.originalFileName = contractImpDto.originalFileName;
                //
                this.startDone(impDto);
            },
            startDone(impDto) {
                let self = this;
                //
                let nextIndex = this.nextIndex;
                let srcContractImpDto = this.contractImpDto;
                let srcContractImpInfoList = srcContractImpDto.impInfoList || [];
                let srcListLength = srcContractImpInfoList.length;

                //
                let srcImpInfo = srcContractImpInfoList[nextIndex];
                impDto.impInfoList = [srcImpInfo];
                impDto.updateFlag = self.fileObj.extra.updateFlag;
                //
                let pageSize = self.pageSize;
                let pageNumber = (nextIndex + 1) / pageSize;
                let pageNumber2 = (nextIndex + 1) % pageSize;
                if (pageNumber2 != 0) {
                    pageNumber = pageNumber + 1;
                }
                let theLoading = MsgBox.loading("总第 " + (nextIndex + 1) + " 行数据...");
                contractApi.doContractImpModelImport(impDto, function (result) {
                    theLoading.close();
                    let resultDto = result.data;
                    if (result.type == 'info') {
                        srcImpInfo.failed = false;
                        srcImpInfo.failDesc = null;
                    } else {
                        srcImpInfo.failed = true;
                        srcImpInfo.failDesc = result.message;
                        self.checkData(false);
                    }
                    //
                    if (!Utils.isNoB(resultDto) && !Utils.isNoB(resultDto.errMsg)) {
                        srcImpInfo.failed = true;
                        srcImpInfo.failDesc = resultDto.errMsg;
                        self.handlePageChange(pageNumber);
                        self.checkData(false);
                        MsgBox.warning("源件行号：" + srcImpInfo.rowNo + "】:" + resultDto.errMsg);
                    } else {
                        //
                        if (nextIndex < (srcListLength - 1)) {
                            self.handlePageChange(pageNumber);
                            self.nextIndex = nextIndex + 1;
                            self.startDone(impDto);
                        } else {
                            //
                            let allDone = srcContractImpInfoList.every(function (item) {
                                return !Utils.isTrue(item.failed);
                            });
                            if (allDone) {
                                self.$emit('other-close');
                            }
                            //
                            return;
                        }
                    }
                });
            },
            replaceSL(str, char) {
                if (!Utils.isNoB(str)) {
                    str = Utils.replace(str, '\r\n', char);
                    str = Utils.replace(str, '\r', char);
                    str = Utils.replace(str, '\n', char);
                }
                return str;
            }
        }
    }
</script>

<style>
    .el-table .row-expand-cover .cell .el-table__expand-icon {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/compo/contract/ContractImpCheck.vue